import { PROFILE_DUCK, REQUEST_STATUS } from '../../core/actions'
import { depositAccountsParser } from '../../utils/financier/depositAccountsParser'
import { financierParser } from '../../utils/financier/financierParsers'
import { gstInvoicesParser } from '../../utils/financier/gstInvoicesParser'
import jsonParse from '../../utils/jsonapi'
import { errorSummary } from '../../utils/misc'
import { extractDocumentIds } from './DocumentsDuck'

export const fetchFinancierAction = () => (authAxios, dispatch, documentsDispatch) => {
  dispatch({ type: PROFILE_DUCK.FETCH_FINANCIER })
  authAxios
    .get('/api/v3/financiers')
    .then(({ data }) => {
      const finData = jsonParse(data).data
      dispatch({ type: PROFILE_DUCK.FETCH_FINANCIER_SUCCESS, payload: financierParser(finData) })
      if (documentsDispatch) extractDocumentIds(finData)(documentsDispatch)
    })
    .catch(error => {
      console.log(`[FETCH][ERROR] Financier data ${error?.message}`)
      dispatch({ type: PROFILE_DUCK.FETCH_FINANCIER_FAILURE })
    })
}

export const fetchWalletAction = () => (authAxios, dispatch) => {
  authAxios
    .get('/api/v3/wallet')
    .then(({ data }) => {
      dispatch({ type: PROFILE_DUCK.FETCH_WALLET_SUCCESS, payload: { walletBalance: data?.wallet_balance } })
    })
    .catch(() => {
      console.error(`Fetching wallet balance failed`)
    })
}

export const updateUserDetailsAction = (userId, data) => authAxios => (successToast, failureToast) => {
  authAxios
    .put(`/api/v1/users/${userId}`, data)
    .then(() => successToast())
    .catch(error => failureToast(errorSummary(error?.response?.data)))
}

export const updateFinancierBankAccountAction = data => authAxios => (onSuccess, onFailure) => {
  authAxios
    .put(`/api/v1/financiers/${data.financier_code}/financier_bank_account/${data.bank_account_code}`, {
      financier_bank_account: data,
    })
    .then(({ data }) => onSuccess(data))
    .catch(error => onFailure(error))
}

export const createFinancierBankAccountAction = data => authAxios => (onSuccess, onFailure) => {
  authAxios
    .post(`/api/v1/financiers/${data.financier_code}/financier_bank_account`, { financier_bank_account: data })
    .then(({ data }) => onSuccess(data))
    .catch(error => onFailure(errorSummary(error?.response?.data)))
}

export const searchGSTInvoicesAction = (financierPAN, query) => (authAxios, dispatch, documentsDispatch) => {
  authAxios
    .post(`/api/v1/financiers/${financierPAN}/search_invoices`, { search_term: query })
    .then(({ data }) => {
      const invoices = jsonParse(data).data
      extractDocumentIds(invoices)(documentsDispatch)
      dispatch({
        type: PROFILE_DUCK.GET_GST_INVOICES,
        payload: {
          gstInvoices: gstInvoicesParser(invoices),
        },
      })
    })
    .catch(error => console.log(error))
}

export const getVerifiedBankAccountAction = financierPAN => (authAxios, dispatch) => {
  authAxios
    .get(`/api/v1/deposit_bank_accounts`, { params: { financier_id: financierPAN } })
    .then(({ data }) => {
      const depositAcnts = jsonParse(data).data
      dispatch({
        type: PROFILE_DUCK.FETCH_DEPOSIT_ACCOUNTS,
        payload: {
          depositAccounts: depositAccountsParser(depositAcnts),
        },
      })
    })
    .catch(error => console.log(error))
}

export const createVerifiedBankAccountAction = (data, financierPAN) => authAxios => (onSuccess, onFailure) => {
  const payload = data?.vpa
    ? {
        deposit_upi_address: data,
        financier_id: financierPAN,
      }
    : {
        deposit_bank_account: data,
        financier_id: financierPAN,
      }
  authAxios
    .post(`/api/v1/${data?.vpa ? 'deposit_upi_addresses' : 'deposit_bank_accounts'}`, payload)
    .then(({ data }) => onSuccess(data))
    .catch(error => onFailure(error))
}

export const deleteVerifiedBankAccountAction =
  (account, financierId, financierPAN) => (authAxios, financierDispatch) => {
    authAxios
      .delete(`/api/v1/${account?.type === 'upi' ? 'deposit_upi_addresses' : 'deposit_bank_accounts'}/${account?.id}`, {
        params: { financier_id: financierId },
      })
      .then(() => {
        getVerifiedBankAccountAction(financierPAN)(authAxios, financierDispatch)
        console.log('Delete successful')
      })
      .catch(err => console.log('Delete failed', err))
  }

export const referralDetailsAction = financierPAN => (authAxios, dispatch) => {
  authAxios.get(`/api/v1/financiers/${financierPAN}/referral_dashboard`).then(({ data }) => {
    dispatch({
      type: PROFILE_DUCK.REFERRAL_DETAILS,
      payload: { referrals: data },
    })
  })
}

export const getNomineeDetailsAction = financierPAN => (authAxios, dispatch) => {
  const data = {
    page: 1,
  }
  authAxios
    .get(`/api/v1/financiers/${financierPAN}/nominees`, { params: data })
    .then(({ data }) => {
      data.data.forEach(user => {
        let email
        let name
        let phone
        let pan
        let relation = user.attributes.designation
        data.included.forEach(entry => {
          if (entry.id === user.relationships.user.data.id) {
            email = entry.attributes.email
            name = entry.attributes.full_name
            phone = entry.attributes.phone
          }
          if (entry.id === user.relationships.person_kyc.data.id) {
            pan = entry.attributes.permanent_account_number
          }
        })
        // TODO Check for multiple nominees and clear nominees at the end
        dispatch({
          type: PROFILE_DUCK.NOMINEE_DETAILS,
          payload: { nominees: { email: email, name: name, phone: phone, pan: pan, relation: relation } },
        })
      })
    })
    .catch(error => {
      console.error(error)
    })
}

export const addNomineeDetailsAction = data => authAxios => (onSuccess, onFailure) => {
  authAxios
    .post(`/api/v1/financiers/${data.financier_id}/nominees`, { nominees: data })
    .then(({ data }) => {
      onSuccess(data)
    })
    .catch(error => {
      onFailure(errorSummary(error?.response?.data))
    })
}

export const fetchMisReportUrlAction = financierPAN => (authAxios, dispatch) => onSuccess => {
  dispatch({ type: PROFILE_DUCK.MIS, payload: { misReportStatus: REQUEST_STATUS.PENDING } })
  authAxios
    .post(`/api/v1/financiers/${financierPAN}/refresh_mis`)
    .then(({ data }) => {
      onSuccess(jsonParse(data)?.data?.document_buyer_mis_reports[0]?.service_url)
      dispatch({ type: PROFILE_DUCK.MIS, payload: { misReportStatus: REQUEST_STATUS.SUCCESS } })
    })
    .catch(() => {
      dispatch({ type: PROFILE_DUCK.MIS, payload: { misReportStatus: REQUEST_STATUS.FAILURE } })
    })
}

export const fetchEarningsReportUrlAction = financierPAN => (authAxios, dispatch) => onSuccess => {
  dispatch({ type: PROFILE_DUCK.EARNINGS_REPORT, payload: { earningsReportStatus: REQUEST_STATUS.PENDING } })
  authAxios
    .post(`/api/v1/financiers/${financierPAN}/refresh_earning_mis`)
    .then(({ data }) => {
      onSuccess(jsonParse(data)?.data?.document_buyer_earning_mis_reports[0]?.service_url)
      dispatch({ type: PROFILE_DUCK.EARNINGS_REPORT, payload: { earningsReportStatus: REQUEST_STATUS.SUCCESS } })
    })
    .catch(() => {
      dispatch({ type: PROFILE_DUCK.EARNINGS_REPORT, payload: { earningsReportStatus: REQUEST_STATUS.FAILURE } })
    })
}

export const fetchOutstandingsReportUrlAction = (financierPAN, date) => (authAxios, dispatch) => onSuccess => {
  dispatch({ type: PROFILE_DUCK.OUTSTANDING_REPORT, payload: { outstandingsReportStatus: REQUEST_STATUS.PENDING } })
  authAxios
    .post(`/api/v1/financiers/${financierPAN}/generate_outstanding_report`, { id: financierPAN, date })
    .then(({ data }) => {
      onSuccess(jsonParse(data)?.data?.service_url)
      dispatch({ type: PROFILE_DUCK.OUTSTANDING_REPORT, payload: { outstandingsReportStatus: REQUEST_STATUS.SUCCESS } })
    })
    .catch(() => {
      dispatch({ type: PROFILE_DUCK.OUTSTANDING_REPORT, payload: { outstandingsReportStatus: REQUEST_STATUS.FAILURE } })
    })
}

export const deleteDocumentAction = (authAxios, documentId) => {
  authAxios
    .delete('/api/v1/documents/' + documentId)
    .then(() => {
      console.log('Document deletion success! with id', documentId)
    })
    .catch(e => {
      console.error('Document deletion failed! with id', documentId, e)
    })
}

export const getBankNameFromIFSC = ifsc => (authAxios, dispatch) => {
  authAxios
    .get('/api/v1/financier_bank_accounts/get_bank_name', { params: { ifsc: ifsc } })
    .then(({ data }) => {
      console.log(`[FETCH][SUCCESS] Bank name with IFSC ${data?.bank_name}`)
      dispatch({ type: PROFILE_DUCK.UPDATE_BANK_VALUES, payload: { updateBank: { bankName: data?.bank_name } } })
    })
    .catch(error => {
      console.error('[FETCH][ERROR] Bank name with IFSC', error)
    })
}

export const FinancierInitialState = {
  status: REQUEST_STATUS.IDLE,
  financier: null,
  nominees: [],
  referrals: [],
  updateBank: {},
  updateBankMessages: {},
  depositAccounts: [],
  gstInvoices: [],
  misReportStatus: REQUEST_STATUS.IDLE,
  earningsReportStatus: REQUEST_STATUS.IDLE,
  outstandingsReportStatus: REQUEST_STATUS.IDLE,
}

export const FinancierReducer = (state, { type, payload }) => {
  switch (type) {
    case PROFILE_DUCK.FETCH_FINANCIER:
      return { ...state, status: REQUEST_STATUS.PENDING }
    case PROFILE_DUCK.FETCH_FINANCIER_SUCCESS:
      return { ...state, status: REQUEST_STATUS.SUCCESS, financier: payload }
    case PROFILE_DUCK.FETCH_FINANCIER_FAILURE:
      return { ...state, status: REQUEST_STATUS.FAILURE }
    case PROFILE_DUCK.FETCH_WALLET_SUCCESS:
      return { ...state, financier: { ...state.financier, ...{ walletBalance: payload.walletBalance } } }
    case PROFILE_DUCK.NOMINEE_DETAILS:
      return {
        ...state,
        nominees: [...new Map([...state.nominees, payload.nominees].map(item => [item['pan'], item])).values()],
      }
    case PROFILE_DUCK.REFERRAL_DETAILS:
      return { ...state, referrals: payload.referrals }
    case PROFILE_DUCK.FETCH_DEPOSIT_ACCOUNTS:
      return { ...state, depositAccounts: payload.depositAccounts }
    // Only for Edit/Add Bank Account
    case PROFILE_DUCK.UPDATE_BANK_VALUES:
      return { ...state, updateBank: { ...state.updateBank, ...payload.updateBank } }
    case PROFILE_DUCK.UPDATE_BANK_MESSAGES:
      return { ...state, updateBankMessages: { ...state.updateBankMessages, ...payload.updateBankMessages } }
    case PROFILE_DUCK.GET_GST_INVOICES:
      return { ...state, gstInvoices: payload.gstInvoices }
    case PROFILE_DUCK.MIS:
      return { ...state, misReportStatus: payload.misReportStatus }
    case PROFILE_DUCK.EARNINGS_REPORT:
      return { ...state, earningsReportStatus: payload.earningsReportStatus }
    case PROFILE_DUCK.OUTSTANDING_REPORT:
      return { ...state, outstandingsReportStatus: payload.outstandingsReportStatus }
    default:
      return state
  }
}
